// Where the customer's chosen location is remembered between pages.
//
// The search bar keeps its state in the URL, which is enough while the customer is on the
// search results. A product page is reached at /{slug} with no query string, so without
// this it would have no idea where they are shopping and could not price a treatment or
// open the booking panel on the right branch.
//
// Read server-side by App\Services\LocationService::bookingLocation(). Written here rather
// than by a POST so changing location costs no round trip - which is why the cookie is on
// the encryptCookies except list in bootstrap/app.php. The id alone goes in: the name is
// derivable, and a cached copy of it would go stale the first time a location is renamed.
// Nothing trusts the value - it is always looked up against Location::live() before use.

// Must match App\Services\LocationService::LOCATION_COOKIE.
const COOKIE_NAME = 'spa_location';

// Mirrors config('basket.cookie_lifetime_days'), which JS cannot read. Not load-bearing:
// an expired cookie just means the customer picks their location again.
const LIFETIME_DAYS = 30;

// Null when nothing has been stored, or when the stored value is not a usable id - a
// hand-edited cookie must not seed the search bar with NaN.
export function readLocationCookie() {
    const match = document.cookie.match(new RegExp(`(?:^|; )${COOKIE_NAME}=([^;]*)`));

    if (! match) {
        return null;
    }

    return Number(decodeURIComponent(match[1])) || null;
}

export function writeLocationCookie(locationId) {
    if (! locationId) {
        return;
    }

    const attributes = [
        `${COOKIE_NAME}=${encodeURIComponent(locationId)}`,
        'path=/',
        `max-age=${LIFETIME_DAYS * 24 * 60 * 60}`,
        'SameSite=Lax',
    ];

    // Omitted on http so local development over a plain connection still stores it.
    if (window.location.protocol === 'https:') {
        attributes.push('Secure');
    }

    document.cookie = attributes.join('; ');
}
